/**
 * InventoryImage.jsx
 * Created by Tim on 12/20/17.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { find } from 'lodash';
import axios from 'axios';

import ImageUnavailable from './ImageUnavailable';

const propTypes = {
    type: PropTypes.string,
    id: PropTypes.string
};

const defaultProps = {};

const imageUnavailable = (
    <div className="rec-inventory-image-wrap">
        <ImageUnavailable />
    </div>
);

export default class InventoryImage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            image: imageUnavailable
        };
    }

    componentWillMount() {
        const { type, id } = this.props;

        if (type && id) {
            this.loadMedia(type, id);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.id && this.props.id !== nextProps.id ||
            nextProps.type && this.props.type !== nextProps.type) {
            this.loadMedia(nextProps.type, nextProps.id);
        }
    }

    loadMedia(type, id) {
        axios.get(`/api/media/public/${type}/${id}`, {})
            .then((res) => {
                if (res && !res.data.err) {
                    if (res.data.result) {
                        const photos = res.data.result;

                        // Set the preview photo, if it exists
                        let previewPhoto = find(photos, { is_preview: true });
                        if (previewPhoto === undefined) {
                            previewPhoto = null;
                        }

                        let image = null;
                        if (!previewPhoto && photos.length > 0) {
                            previewPhoto = photos[0];
                        }
                        if (previewPhoto) {
                            image = (
                                <div className="rec-inventory-image-wrap">
                                    <img
                                        src={previewPhoto.url}
                                        alt={previewPhoto.title}
                                        aria-label={previewPhoto.title} />
                                </div>
                            );
                        }
                        else {
                            image = imageUnavailable;
                        }

                        this.setState({ image });
                    }
                    else {
                        this.setState({
                            image: imageUnavailable
                        });
                    }
                }
                else {
                    this.setState({
                        image: imageUnavailable
                    });
                }
            })
            .catch(() => {
                this.setState({
                    image: imageUnavailable
                });
            });
    }

    render() {
        return this.state.image;
    }
}

InventoryImage.propTypes = propTypes;
InventoryImage.defaultProps = defaultProps;
